/**
 * Asynchronously fires analytics tags.
 * This is to avoid blocking the main thread.
 *
 * @param {Function} fireTagFunction - A function that, when called, fires a tag.
 *   Example: () => fireTag('view', { page_name: 'home' })
 * @returns {Promise<boolean>} A promise that resolves to true if the tag fired successfully, and false otherwise.
 */
export default async function useFireTagAsync(fireTagFunction) {
  if (typeof fireTagFunction !== 'function') {
    console.error('useFireTagAsync: Provided parameter is not a function.'); // eslint-disable-line no-console
    return false;
  }
  try {
    await Promise.resolve(fireTagFunction());
  } catch (e) {
    console.error('useFireTagAsync: Error firing tag:', e); // eslint-disable-line no-console
    return false;
  }
  return true;
}
